import { COLORS } from "@/utils/constants";
import DotElement from "@/components/tableElements/DotElement.vue";
import AppIcon from "@/components/AppIcon.vue";
export default {
  name: "EvolutionArrow",
  components: {
    DotElement,
    AppIcon
  },
  props: {
    value: {
      type: Number
    },
    change: {
      type: String,
      default: "positive"
    }
  },
  computed: {
    computedValue() {
      return this.value === null ? this.value : this.value * 100;
    },
    iconInfo() {
      const changes = {
        positive: () => {
          return Math.round(this.computedValue) > 0 ? {
            icon: "arrow-up",
            color: COLORS.EVOLUTION_GREEN
          } : {
            icon: "arrow-down",
            color: COLORS.EVOLUTION_RED
          };
        },
        negative: () => {
          return Math.round(this.computedValue) < 0 ? {
            icon: "arrow-up",
            color: COLORS.EVOLUTION_GREEN
          } : {
            icon: "arrow-down",
            color: COLORS.EVOLUTION_RED
          };
        }
      };
      return this.computedValue === null ? {} : changes[this.change]();
    }
  }
};